/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * Meeting BaaS API
 * OpenAPI spec version: 1.1
 */

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteStatus = {
  deleted: "deleted",
  partiallyDeleted: "partiallyDeleted",
  alreadyDeleted: "alreadyDeleted",
  noDataFound: "noDataFound"
} as const
export type DeleteStatus = (typeof DeleteStatus)[keyof typeof DeleteStatus]
